import { Box } from "@mui/material";
import React, { useRef, useState } from "react";
import "./videoPlayer.scss";
function VideoPlayer() {
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  const handlePlay = () => {
    setIsPlaying(true);
    videoRef.current.play();
  };
  const handleVideoEnded = () => {
    setIsPlaying(false);
  };
  return (
    <Box
      className="video-player"
      sx={{
        width: { lg: "100%", sm: "100%" },
        height: {
          lg: "100%",
          sm: "auto",
        },
        [`@media (min-width: 1499px) and (max-width:1879px)`]: { width: "96%", height: "100%" },


        [`@media (min-width: 3800px)`]: { width: "100%", height: "auto" },
      }}
    >
      {!isPlaying ? (
        <div className="poster" onClick={handlePlay}>
          <img className="poster-image" src="/assets/images/videoPoster.png" />
          <div className="play-button" onClick={handlePlay}>
            <img src="../assets/icons/play-button.png" />
          </div>
        </div>
      ) : (
        <div className="poster">
          <video
            controls
            controlsList="nodownload"
            className="poster-image"
            ref={videoRef}
            autoPlay
            //loop
            width={620}
            height={360}
            onEnded={handleVideoEnded}
          >
            <source
              src="assets/videos/generational-consulting.mov"
              type="video/mp4"
            />
          </video>
        </div>
      )}
    </Box>
  );
}

export default VideoPlayer;
